import Big from 'big.js';

export default function calculateAverageUnitPrice(order) {
  if (order.fills.length > 0) {
    const sums = order.fills.reduce(
      (totalPrice, fill) => {
        const paidForFill = Big(fill.price).times(fill.quantity);
        return {
          fillsQuantity: totalPrice.fillsQuantity.plus(fill.quantity),
          totalPaidForFills: totalPrice.totalPaidForFills.plus(paidForFill)
        };
      },
      { fillsQuantity: Big(0), totalPaidForFills: Big(0) }
    );

    return sums.totalPaidForFills.div(sums.fillsQuantity).toString();
  }
  return null;
}
